<template>
  <div id="expertview-writeable-values">
    <cactus-groups :groups="cactusGroups" :multiple="true"></cactus-groups>
  </div>
</template>

<script>
import CactusGroups from './CactusGroups.vue';

export default {
  name: 'ExpertviewWriteable',
  components: { CactusGroups },
  data: function() {
    return {
      cactusGroups: require('./cactus_groups.json')
    };
  },
  created() {
    this.$log.debug('ExpertviewWriteable::created()');
  }
};
</script>

<style scoped></style>
